module.exports = __webpack_public_path__ + "media/images/front/treatment_support/setting_add_home_screen/img02-c87f7e7ba6137e8ea6b286ff6174ae8f.png";